import {SingletonService} from '@/common/dependency.configs'
import {injectable} from 'inversify'
import order from '@/common/services/Order'

@SingletonService
@injectable()
class RemainingTypeCodesFilter {
  remainingTypeCodes<T extends {typeCode: string; displayOrder?: number}, K extends {required?: boolean}>(
    typeList: Array<T>,
    objectList: Array<K>,
    typeCodeName: keyof K
  ): Array<T & {disabled?: boolean}> {
    const requiredObjects = objectList.filter((object) => object.required)

    const typeCodeIsDisabled = (type: T) => objectList.some((object) => type.typeCode == object[typeCodeName])

    const remainingTypes = typeList
      .filter((type) => !requiredObjects.some((requiredObject) => requiredObject[typeCodeName] == type.typeCode))
      .reduce((acc: Array<T>, cur: T, index: number) => {
        acc.push({
          ...cur,
          disabled: typeCodeIsDisabled(cur),
          displayOrder: cur.displayOrder ? cur.displayOrder : index + 1
        })
        return acc
      }, [])

    return order(remainingTypes).numericAscendingBy('displayOrder').toArray()
  }

  nextAvailableType<T extends {typeCode: string; displayOrder?: number}, K extends {required?: boolean}>(
      typeList: Array<T>,
      objectList: Array<K>,
      typeCodeName: keyof K
  ): Array<T & {disabled?: boolean}> {
      return this.remainingTypeCodes(
          typeList,
          objectList,
          typeCodeName
      ).filter(result => !result.disabled)
  }
}

export default RemainingTypeCodesFilter
